import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function PaymentSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    const sid = params.get("session_id"); if (!sid) return;
    let tries = 0;
    const poll = async () => {
      tries++;
      try {
        const r = await api.get(`/payments/status/${sid}`);
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (tries < 12) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [params]);
  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid="payment-success">
      <CheckCircle2 size={64} className="mx-auto mb-6" style={{ color: "var(--brand)" }} />
      <h1 className="font-serif text-4xl mb-4" style={{ color: "var(--ink)" }}>
        {status === "paid" ? t({ en: "Session confirmed", fr: "Séance confirmée" }) : status === "checking" ? t({ en: "Confirming your payment…", fr: "Confirmation de votre paiement…" }) : t({ en: "Almost there", fr: "Presque terminé" })}
      </h1>
      <p className="mb-8" style={{ color: "var(--ink-2)" }}>
        {status === "paid" ? t({ en: "A confirmation email is on its way. See you soon.", fr: "Un courriel de confirmation arrive. À bientôt." }) : t({ en: "Please give us a moment while we verify with our payment processor.", fr: "Un instant pendant que nous vérifions avec notre processeur de paiement." })}
      </p>
      <Link to="/portal" className="btn-primary">{t({ en: "Go to Portal", fr: "Aller à l'espace client" })}</Link>
    </div>
  );
}
